import React, { lazy } from 'react';
import {
  DashboardOutlined,
  SettingOutlined,
  AppstoreOutlined,
  DatabaseOutlined,
  BankOutlined,
  CloudServerOutlined,
  FileTextOutlined,
  QuestionCircleOutlined,
  CommentOutlined,
  StarOutlined,
  ShoppingOutlined,
  CrownOutlined,
  UploadOutlined,
  ToolOutlined,
  BgColorsOutlined,
  HistoryOutlined,
  LaptopOutlined,
} from '@ant-design/icons';

export const routesConfig = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: <DashboardOutlined />,
    Component: lazy(() =>
      import('components/modules/DashboardComponent').then((module) => ({
        default: module.DashboardComponent,
      })),
    ),
  },
  {
    label: 'Administration',
    path: '/administration',
    icon: <SettingOutlined />,
    children: [
      {
        label: 'Platform',
        path: '/administration/platform',
        Component: lazy(() =>
          import('components/modules/PlatformComponent').then((module) => ({
            default: module.PlatformComponent,
          })),
        ),
      },
      {
        label: 'Modules',
        path: '/administration/modules',
        Component: lazy(() =>
          import('components/modules/ModulesComponent').then((module) => ({
            default: module.ModulesComponent,
          })),
        ),
      },
      {
        label: 'Permission Index',
        path: '/administration/permission-index',
        Component: lazy(() =>
          import('components/modules/PermissionIndexComponent').then(
            (module) => ({ default: module.PermissionIndexComponent }),
          ),
        ),
      },
      {
        label: 'Roles & Access',
        path: '/administration/roles-access',
        Component: lazy(() =>
          import('components/modules/RolesAccessComponent').then((module) => ({
            default: module.RolesAccessComponent,
          })),
        ),
      },
      {
        label: 'User Management',
        path: '/administration/user-management',
        Component: lazy(() =>
          import('components/modules/UserManagementComponent').then(
            (module) => ({ default: module.UserManagementComponent }),
          ),
        ),
      },
      {
        label: 'Adviser Management',
        path: '/administration/adviser-management',
        Component: lazy(() =>
          import('components/modules/AdvisersManagementComponent').then(
            (module) => ({
              default: module.AdvisersManagementComponent,
            }),
          ),
        ),
      },
    ],
  },
  {
    label: 'Providers',
    path: '/providers',
    icon: <BankOutlined />,
    Component: lazy(() =>
      import('components/modules/BanksManagementComponent').then((module) => ({
        default: module.BanksManagementComponent,
      })),
    ),
  },
  {
    label: 'Warehouses',
    path: '/warehouses',
    icon: <CloudServerOutlined />,
    Component: lazy(() =>
      import('components/modules/WarehouseManagementComponent').then(
        (module) => ({ default: module.WarehouseManagementComponent }),
      ),
    ),
  },
  {
    label: 'CMS',
    path: '/cms',
    icon: <FileTextOutlined />,
    children: [
      {
        label: 'Pages',
        path: '/cms/pages',
        Component: lazy(() =>
          import('components/modules/PagesManagementComponent').then(
            (module) => ({ default: module.PagesManagementComponent }),
          ),
        ),
      },
      {
        label: 'Posts',
        path: '/cms/posts',
        Component: lazy(() =>
          import('components/modules/PostManagementComponent').then(
            (module) => ({ default: module.PostManagementComponent }),
          ),
        ),
      },
      {
        label: 'Assets',
        path: '/cms/assets',
        Component: lazy(() =>
          import('components/modules/CMSAssetsManagementComponent').then(
            (module) => ({ default: module.CMSAssetsManagementComponent }),
          ),
        ),
      },
      {
        label: 'Post Sub-Contents',
        path: '/cms/post/sub-contents',
        Component: lazy(() =>
          import('components/modules/CMSPostContentManagementComponent').then(
            (module) => ({
              default: module.CMSPostContentManagementComponent,
            }),
          ),
        ),
      },
      {
        label: 'FAQs',
        path: '/faq',
        icon: <QuestionCircleOutlined />,
        children: [
          {
            label: 'FAQ Index',
            path: '/faq/index',
            Component: lazy(() =>
              import('components/modules/FAQIndexManagementComponent').then(
                (module) => ({
                  default: module.FAQIndexManagementComponent,
                }),
              ),
            ),
          },
          {
            label: 'FAQ Group',
            path: '/faq/group',
            Component: lazy(() =>
              import('components/modules/FAQManagementComponent').then(
                (module) => ({ default: module.FAQManagementComponent }),
              ),
            ),
          },
        ],
      },
      {
        label: 'Remarks',
        path: '/remarks',
        icon: <CommentOutlined />,
        children: [
          {
            label: 'Remarks Index',
            path: '/remarks/index',
            Component: lazy(() =>
              import('components/modules/RemarksIndexManagementComponent').then(
                (module) => ({
                  default: module.RemarksIndexManagementComponent,
                }),
              ),
            ),
          },
          {
            label: 'Remarks Group',
            path: '/remarks/group',
            Component: lazy(() =>
              import('components/modules/RemarksSubGroupManagementComponent').then(
                (module) => ({
                  default: module.RemarksSubGroupManagementComponent,
                }),
              ),
            ),
          },
        ],
      },
    ],
  },
  {
    label: 'Reviews',
    path: '/reviews',
    icon: <StarOutlined />,
    children: [
      {
        label: 'Reviews Index',
        path: '/reviews',
        Component: lazy(() =>
          import('components/modules/ReviewsManagementComponent').then(
            (module) => ({ default: module.ReviewsManagementComponent }),
          ),
        ),
      },
      {
        label: 'Reviews Group',
        path: '/reviews-group',
        Component: lazy(() =>
          import('components/modules/ReviewsGroupManagementComponent').then(
            (module) => ({
              default: module.ReviewsGroupManagementComponent,
            }),
          ),
        ),
      },
    ],
  },
  {
    label: 'Ads',
    path: '/ads',
    icon: <AppstoreOutlined />,
    Component: lazy(() =>
      import('components/modules/AdsManagementComponent').then((module) => ({
        default: module.AdsManagementComponent,
      })),
    ),
  },
  {
    label: 'Auctions',
    path: '/auctions',
    icon: <CrownOutlined />,
    children: [
      {
        label: 'Bidding Winners',
        path: '/auctions/biddings-winner',
        Component: lazy(() =>
          import('components/modules/BiddingWinnersManagementComponent').then(
            (module) => ({
              default: module.BiddingWinnersManagementComponent,
            }),
          ),
        ),
      },
      {
        label: 'Auction Reports v2 - Bid',
        path: '/auctions/reports-v2',
        Component: lazy(() =>
          import('components/modules/AuctionReportsV2Component').then(
            (module) => ({
              default: module.AuctionReportsV2Component,
            }),
          ),
        ),
      },
      {
        label: 'Buy Now Winners',
        path: '/auctions/buynow-winner',
        Component: lazy(() =>
          import('components/modules/BuyNowWinnersManagementComponent').then(
            (module) => ({
              default: module.BuyNowWinnersManagementComponent,
            }),
          ),
        ),
      },
      {
        label: 'Auction Closer',
        path: '/auctions/closer',
        Component: lazy(() =>
          import('components/modules/AuctionCloserComponent').then(
            (module) => ({ default: module.AuctionCloserComponent }),
          ),
        ),
      },
    ],
  },
  {
    label: 'Bulk Uploader',
    path: '/bulk-uploader',
    icon: <UploadOutlined />,
    Component: lazy(() =>
      import('components/modules/BulkUploaderManagementComponent').then(
        (module) => ({ default: module.BulkUploaderManagementComponent }),
      ),
    ),
  },
  {
    label: 'Financing Uploader',
    path: '/financing-uploader',
    icon: <UploadOutlined />,
    Component: lazy(() =>
      import('components/modules/FinancingUploaderManagementComponent').then(
        (module) => ({ default: module.FinancingUploaderManagementComponent }),
      ),
    ),
  },
  {
    label: 'Orders',
    path: '/orders',
    icon: <ShoppingOutlined />,
    Component: lazy(() =>
      import('components/modules/OrdersComponent').then((module) => ({
        default: module.OrdersComponent,
      })),
    ),
  },
  {
    label: 'Settings',
    path: '/settings',
    icon: <ToolOutlined />,
    Component: lazy(() =>
      import('components/modules/OptionsComponent').then((module) => ({
        default: module.OptionsComponent,
      })),
    ),
  },
  {
    label: 'Item Settings',
    path: '/item',
    icon: <DatabaseOutlined />,
    children: [
      {
        label: 'Makes',
        path: '/item/makes',
        Component: lazy(() =>
          import('components/modules/ItemMakesManagementComponent').then(
            (module) => ({ default: module.ItemMakesManagementComponent }),
          ),
        ),
      },
      {
        label: 'Models',
        path: '/item/models',
        Component: lazy(() =>
          import('components/modules/ItemModelsManagementComponent').then(
            (module) => ({ default: module.ItemModelsManagementComponent }),
          ),
        ),
      },
      {
        label: 'Vehicle Types',
        path: '/item/vehicle-types',
        Component: lazy(() =>
          import('components/modules/ItemVehicleTypeManagementComponent').then(
            (module) => ({
              default: module.ItemVehicleTypeManagementComponent,
            }),
          ),
        ),
      },
      {
        label: 'Colors',
        path: '/item/colors',
        icon: <BgColorsOutlined />,
        Component: lazy(() =>
          import('components/modules/ColorsComponent').then((module) => ({
            default: module.ColorsComponent,
          })),
        ),
      },
    ],
  },
  {
    label: 'Activity Logs',
    path: '/activity',
    icon: <HistoryOutlined />,
    Component: lazy(() =>
      import('components/modules/ActivityLogsManagementComponent').then(
        (module) => ({ default: module.ActivityLogsManagementComponent }),
      ),
    ),
  },
  {
    label: 'Active Sessions',
    path: '/active-sessions',
    icon: <LaptopOutlined />,
    Component: lazy(() =>
      import('components/modules/SessionComponent').then((module) => ({
        default: module.SessionComponent,
      })),
    ),
  },
  {
    label: 'NPS',
    path: '/nps',
    icon: <StarOutlined />,
    Component: lazy(() =>
      import('components/modules/NPSByAdviserComponent').then((module) => ({
        default: module.NPSByAdviserComponent,
      })),
    ),
  },
];
